import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { Alerta } from "src/app/models/Alertas/Alerta";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";

@Component({
	selector: "app-alerta-entry",
	templateUrl: "./alerta-entry.component.html",
	styleUrls: ["./alerta-entry.component.scss"],
})
export class AlertaEntryComponent implements OnInit {
	@ViewChild("alertFormRef") private childFormRef: NgForm;
	public alertForm: FormGroup;
	public showCount = false;
	private alertObj: Alerta = new Alerta();
	@Input() public alertToEdit: Alerta = new Alerta();
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendAlertRequest: EventEmitter<any> = new EventEmitter<any>();
	constructor(private formBuilder: FormBuilder, private tokenStorage: TokenStorageService, public permissions: PermissionService) {}

	ngOnInit(): void {
		this.createForm();
		this.showCount = this.alertToEdit.alertaId == 5 ? true : false;
		// if (this.editMode) {
		//   this.setalertDataToForm(this.alertToEdit);
		// }
		this.setalertDataToForm(this.alertToEdit);
	}

	onSubmit() {
		if (this.alertForm.valid) {
			this.getFormData();
			this.sendAlertRequest.emit(this.alertObj);
		}
	}
	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}

	getFormData() {
		//var rut = this.alertForm.controls.rutString.value;
		this.alertObj.umbralCantidad = this.alertForm.controls.umbralCantidad.value;
		this.alertObj.umbralDias = this.alertForm.controls.umbralDias.value;
		this.alertObj.alertaId = this.alertToEdit.alertaId;
	}

	setalertDataToForm(alert: Alerta) {
		this.alertForm.patchValue(alert);
		this.alertForm.get("nombre").patchValue(alert.nombre);
		this.alertForm.get("umbralDias").patchValue(alert.umbralDias);
		this.alertForm.get("umbralCantidad").patchValue(alert.umbralCantidad);
	}

	createForm() {
		this.alertForm = this.formBuilder.group({
			umbralCantidad: [""],
			umbralDias: [""],
			nombre: ["", Validators.required],
		});
	}
}
